// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-header[data-v-cebd88f0]{display:flex;justify-content:space-between;background-color:#fff;height:60px}.center-section[data-v-cebd88f0]{display:flex;flex-basis:100%}.left-section[data-v-cebd88f0],.right-section[data-v-cebd88f0]{display:flex;align-items:center;box-sizing:border-box}.divider[data-v-cebd88f0]{height:100%}", ""]);
// Exports
module.exports = exports;
